import templateUrl from 'emun.salesrep/salesrep-top-customers.htm';
import basicController from "servicestack/basic.controller.properties";

class SalesRepTopCustomersController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this;
		basicController($ctrl);
		$ctrl.utils = utils;
		var context = $ctrl.context || 'rep';
		var queryCriteria = '';

		var filter = "RepId";
		if (context == 'executive') {
			filter = '';
		}
		else if (context === 'vendor') {
			filter = 'VendorId' + '=' + $ctrl.rep.id;
		} else if (context === 'subrep') {
			filter = 'SubRepId' + '=' + $ctrl.rep.id;
		} else if (context === 'manager') {
			filter = 'ManagerId' + '=' + $ctrl.rep.id;
		} else {
			filter = filter + '=' + $ctrl.rep.id;
			if ($ctrl.repGroup) {
				if ($ctrl.repGroup !== 'ALL') {
					filter = filter + '&RepGroupName=' + $ctrl.repGroup;
				}
			}
		}
		if ($ctrl.insideSales === 'true') {
			queryCriteria = '&IsInsideSales=true';
		}
		if ($ctrl.onlyKeyAccounts === 'true') {
			queryCriteria = '&OnlyKeyAccounts=true';
		}
		//console.info('date r: ' + $ctrl.dateRange + ' : title: ' + $ctrl.title);
		var dateRange = $ctrl.dateRange || "Last12Months";
		this.topCustomers = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?ByCurrentRep=true&Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=' + dateRange + '&' + filter + '&GroupBy=CustomerID,CustomerName' + queryCriteria,
			autoLoad: true,
			pageSize: 10
		});
	}
	//downloadData() {
	//	let $ctrl = this;
	//	var url = $ctrl.$appConfig.serviceUrl + "" + $ctrl.topCustomers.url.replace(".json", ".csv");
	//	return location.href = url;
	//}
	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			name: 'Name',
			amount: "Amount",
			numorders: "# Orders"
		};

		// format the data
		$ctrl.topCustomers.results.forEach((item) => {
			itemsFormatted.push({
				name: item.customerName.replace(/,/g, ''), // remove commas to avoid errors,
				amount: item.sumOrderTotal,
				numorders: item.sumOrderCount,
			});
		});

		var fileTitle = 'salesrep-top-customers';
		$ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'amount').reverse(), fileTitle);
	}
}

let SalesRepTopCustomers = {
	bindings: {
		rep: '<',
		repGroup: '@',
		context: '@',
		dateRange: '@',
		title: '@',
		insideSales: '@',
		onlyKeyAccounts: '@'
	},
	controller: SalesRepTopCustomersController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}


export default SalesRepTopCustomers;